import { defineFcm } from '../shared/factory';

export const FCM_BLOCKED_SIGNATURE_EXPORT = defineFcm('blocked_signature_export')
	.asBoolean()
	.withDefault(false)
	.toConfig();
